<template>
  <div class="container-table reset-password">
      <div class="row vertical-10p">
        <div>
          <h1 class="headerone__default__large">Enter your new password here:</h1>
          <el-input type="password" v-model="newPassword" auto-complete="off"></el-input>
          <el-button type="primary" @click="save()" class="btn__default save-btn">Save</el-button>
          <transition name="fade" mode="out-in" v-if="loading">
            <div class="campaign-loader">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg>
              </div>
            </div>
          </transition>
          <p v-if="!success" class="invalid status-text">{{ message }}</p>
          <p v-if="success" class="valid status-text">Password has been reset! You are being redirected in {{ countdown }} seconds.</p>
        </div>
      </div>
  </div>
</template>

<script>
import { stringify } from 'qs'

export default {
  name: 'reset-password',

  data() {
    return {
      loading : false,
      message: null,
      newPassword: null,
      success: false,
      countdown: 3,
    }
  },

  computed: {
    apiEndpoint() {
      return this.$store.getters.baseEndpoint + 'affiliate/' + this.$route.params.affiliate_id + '/reset-password/' + this.$route.params.hash
    }
  },

  watch: {
    success(newVal, oldVal) {
      if (!oldVal && newVal) {
        var self = this
        // Set time out to redirect
        setTimeout(function() { self.$router.push({ name: 'login'}) }, self.countdown * 1000)
        // Start count down
        setInterval(function() { self.countdown -= 1 }, 1000);
      }
    },
  },

  methods: {
    save() {
      if (this.newPassword == null) {
        this.message = 'Password can not be empty!'
        return
      }
      this.loading = true
      this.$http.post(this.apiEndpoint, stringify({new_password: this.newPassword}))
        .then((response) => {
          this.loading = false
          this.success = true
          this.message = null
        })
        .catch((error) => {
          this.loading = false
          if (this.$http.isApiError(error)) {
            this.success = false
            this.message = error.response.data._meta.errors.join(", ")
          }
        })
    },
  }
};
</script>

<style lang="scss" scoped>
.reset-password{
  width: 475px;
  margin: 0 auto;
  padding: 100px 0;

  .headerone__default__large{
    font-size: 30px;
    font-family: "Interface", Arial;
    line-height: normal;
    margin-bottom: 15px;
    font-weight: bold;
  }
  .status-text{
    font-family: "Interface", Arial;
    font-size: 14px;
    &.valid{
      color: green;
    }
    &.invalid{
      color: red;
    }
  }
  .campaign-loader{
    height: 0;
    .el-loading-spinner{
      position: relative;
      top: -53px;
      text-align: left;
      left: 73px;
      margin: 0;
      .el-loading-spinner .circular{
        width: 25px;
        height: 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// reset-password.vue?2a3f58af